export class StudentAssessmentScale {
    assessmentId: number;
    sectionSubjectId: number;
    rawMark?: number;
    scaledMark?: number;
    studentId: string;
    studentName: string;
    studentNameEn: string;
    studentNumber: string;
    scalingPercentage?: number;
    scalingActualPoint?: number;
    methodScaleId?: number;
    groupScaleId?: number;

}
